module.exports = __webpack_public_path__ + "img/question-continue.7cfae96a.png";